var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 7.55255 4.28559 8.92187 5.48441 9.73183C6.02899 10.0998 6.48633 10.726 6.4997 11.5H9.5003C9.51367 10.726 9.97101 10.0998 10.5156 9.73183C11.7144 8.92187 12.5 7.55255 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5ZM9.5 13H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13ZM2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 8.0717 12.9494 9.89775 11.3553 10.9747C11.1084 11.1416 11 11.3597 11 11.5348V14C11 15.1046 10.1046 16 9 16H7C5.89543 16 5 15.1046 5 14V11.5348C5 11.3597 4.89163 11.1416 4.64466 10.9747C3.05062 9.89775 2 8.0717 2 6Z",
    fill: "#B38600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpike);
export default __webpack_public_path__ + "static/media/spike.01c410de8a29f079e74fb0a20c09cacc.svg";
export { ForwardRef as ReactComponent };